/**   */
import { axios } from '@/utils/request'

export function SupplyAndDemandInfoWebPage(parameter) {
  return axios({
    url: '/SupplyAndDemandInfo/web/page',
    method: 'get',
    params: parameter
  })
}
export function SupplyAndDemandInfoWebHits(parameter) {
  return axios({
    url: '/SupplyAndDemandInfo/web/hits',
    method: 'get',
    params: parameter
  })
}

export function SupplyAndDemandInfoDetail(parameter) {
  return axios({
    url: '/SupplyAndDemandInfo/detail',
    method: 'get',
    params: parameter
  })
}
export function SupplyAndDemandInfoWebMatch(parameter) {
  return axios({
    url: '/SupplyAndDemandInfo/web/match',
    method: 'get',
    params: parameter
  })
}
